import { Injectable, Injector } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { LanguageService } from './language.service';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LanguageInterceptorService implements HttpInterceptor {
  constructor(public injector: Injector) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const langProvider: LanguageService = this.injector.get(LanguageService);
    return from(langProvider.getLanguage()).pipe(
      mergeMap((lang: string) => {
        const headers = lang
          ? req.headers.set('Accept-Language', lang)
          : req.headers;

        const newRequest = req.clone({ headers });
        return next.handle(newRequest);
      })
    );
  }
}

export const translationProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: LanguageInterceptorService,
  multi: true,
};
